var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFutureProof(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_18_2072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_18_2072)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5007 19.8438C22.6361 19.8438 21.1152 21.3646 21.1152 23.2292C21.1152 25.0938 22.6361 26.6146 24.5007 26.6146C26.3652 26.6146 27.8861 25.0938 27.8861 23.2292C27.8861 21.3646 26.3652 19.8438 24.5007 19.8438ZM25.5423 22.8958C25.5423 23.5313 25.1986 24.1354 24.6569 24.4583L23.8548 24.9375C23.7298 25.0104 23.5944 25.0521 23.4486 25.0521C23.1882 25.0521 22.9277 24.9167 22.7819 24.6771C22.5632 24.3021 22.6777 23.8229 23.0527 23.6042L23.8444 23.125C23.9277 23.0729 23.9694 22.9896 23.9694 22.9062V21.9375C23.9694 21.5104 24.3236 21.1563 24.7507 21.1563C25.1777 21.1563 25.5423 21.5 25.5423 21.9271V22.8958Z",
    fill: "#34D399"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3128 15.5944L25.5836 13.4486C24.9899 13.2299 24.0211 13.2299 23.4274 13.4486L17.6982 15.5944C16.5941 16.0111 15.6982 17.3028 15.6982 18.4799V26.9173C15.6982 27.7611 16.2503 28.8757 16.9274 29.3757L22.6565 33.6569C23.6669 34.4173 25.3232 34.4173 26.3336 33.6569L32.0628 29.3757C32.7399 28.8652 33.292 27.7611 33.292 26.9173V18.4799C33.3025 17.3028 32.4065 16.0111 31.3128 15.5944ZM24.5003 28.1777C21.7712 28.1777 19.5524 25.959 19.5524 23.2298C19.5524 20.5007 21.7712 18.2819 24.5003 18.2819C27.2294 18.2819 29.4482 20.5007 29.4482 23.2298C29.4482 25.959 27.2294 28.1777 24.5003 28.1777Z",
    fill: "#34D399"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2072",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2072",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFutureProof);
export default __webpack_public_path__ + "static/media/icon-future-proof.79afe753ee3da1180ae78c4bcc4786a2.svg";
export { ForwardRef as ReactComponent };